import { call, put, select } from 'redux-saga/effects';
import isEqual from 'lodash.isequal';
import { selectDeviceType } from 'features/application/applicationSlice';
import {
  selectRemotePinnedPanels,
  selectPinnedPanels,
  pinnedPanelsReceived,
} from 'features/side-panels/sidePanelsSlice';
import { SidePanelType } from 'features/side-panels/types';
import { filterAccessiblePanels } from './filterAccessiblePanels';
import { isMobileViewport } from './isMobileViewport';

export function* reEvaluateAccessiblePinnedPanelsSaga() {
  const remotePanels: SidePanelType[] = yield select(selectRemotePinnedPanels);

  if (!remotePanels.length) {
    return;
  }

  const deviceType: string = yield select(selectDeviceType);
  const isMobile: boolean = yield call(isMobileViewport, deviceType);

  if (isMobile) {
    return;
  }

  const filtered: SidePanelType[] = yield call(filterAccessiblePanels, remotePanels);
  const current: SidePanelType[] = yield select(selectPinnedPanels);

  if (isEqual(filtered, current)) {
    return;
  }

  yield put(pinnedPanelsReceived({ panels: filtered }));
}
